module.exports = __webpack_public_path__ + "img/17873_S.f49b79d7.png";